export const getNotifications = (user) => {
    return user && user.notifications;
};

export const countNotifications = (user) => {
    const notifications = getNotifications(user);
    return !!notifications ? notifications.filter(n => !n.read_at).length : 0;
};